<template>
  <div class="gallery-tag-list-editor">
    <v-select
      multiple
      :taggable="canCreate"
      :filterable="false"
      :closeOnSelect="false"
      :options="results"
      :createOption="createOption"
      :value="selected.slice()"
      @search="search"
      @input="onInput"
      @keyup.native="handleEmptySearch"
      placeholder="Example">
      <template slot="no-options">
        Search tags...
      </template>
    </v-select>
  </div>
</template>

<script>
  import Galleries from '../../services/galleries';

  export default {
    name: 'gallery-tag-list-editor',

    props: {
      canCreate: {
        type: Boolean,
        default: false
      },
      value: {
        type: Array,
        // [ { id, name } ]
        // v-model is supported
      }
    },

    data() {
      return {
        results: [],
        selected: [] // Synced with `value` prop if prop is provided
      };
    },

    methods: {
      reset() {
        this.results = [];
        this.selected = [];
        this.$emit('input', this.selected);
      },

      createOption(newOption) {
        // v-select will call this before creating new tags, to give us the
        // option to customize them. We want to make sure to give the options
        // both a label (for v-select) and a name (for us).
        if (typeof newOption === 'string') {
          newOption = {
            label: newOption.trim()
          };
        }
        newOption.label = newOption.label.trim();
        newOption.name = newOption.label;
        return newOption;
      },

      onInput(newSelected) {
        // vue-select likes to say the input has changed when it really hasn't,
        // which causes headaches for us elsewhere. Do a deep compare to make
        // sure something has actually changed.
        if (JSON.stringify(this.selected) === JSON.stringify(newSelected)) {
          return;
        }

        // Clear the search results each time a tag is selected
        this.results = [];

        // Save the new tags
        this.selected = newSelected;

        // Propogate the event
        this.$emit('input', this.selected);
      },

      search(searchTerm, setLoading) {
        setLoading(true);
        Galleries.searchTags(searchTerm.trim()).then(tags => {
          this.results = tags.map(tag => {
            return {
              id:    tag.id,
              name:  tag.name,
              label: tag.name
            };
          });
          setLoading(false);
        });
      },

      handleEmptySearch(ev) {
        // search() is only called when the search term is non-empty (this is a
        // known bug in the library); this method should check for an empty
        // search string and clear the results when found.
        if (ev.target.value.length === 0) {
          this.results = [];
        }
      },
    },

    watch: {
      value: {
        immediate: true,
        handler: function() {
          // Ensure each tag in the array has a label (for v-select)
          const newSelected = this.value.map(tag => {
            return {
              id:    tag.id,
              name:  tag.name,
              label: tag.label || tag.name
            };
          });

          // We do a deep compare here instead of just overwriting `selected` to
          // avoid an infinite loop of updating `selected`, which updates
          // `value`, which updates `selected`, ...
          if (JSON.stringify(newSelected) !== JSON.stringify(this.selected)) {
            this.selected = newSelected;
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .clear-button {
    border: none;
    background: none;
  }

  .v-select {
    border-bottom: 1px solid #fff;
    font-family: inherit;
  }
</style>

<style lang="scss">
  .gallery-tag-list-editor {
    .v-select {
      padding: 4px 0;

      input {
        border-bottom: none !important;
      }
      .selected-tag {
        background: transparent;
        border: solid 1px #33ccff;
        border-radius: 4px;
        color: #33ccff;
        margin: 4px 5px 4px 0;
        padding: 4px 8px;
        line-height: 17px;
        font-size: 12px;
        &::before {
          content: '#';
        }
        .close {
          color: #33ccff;
          opacity: 0.8;
          line-height: 17px;
          font-size: 16px;
        }
      }

      .dropdown-toggle {
        border: none;
      }

      .dropdown-menu {
        background-color: #363636;
        border: 1px solid #666;
        padding: 0;
        overflow-y: auto;
        max-height: 200px;
        li a {
          color: #ebebeb;
        }
        li.highlight a {
          color: white;
        }
      }

      .clear {
        color: #555;
      }

      .open-indicator::before {
        border-color: #b0b0b0;
      }

      .spinner {
        border-top-color: rgba(255, 255, 255, 0.2);
        border-right-color: rgba(255, 255, 255, 0.2);
        border-bottom-color: rgba(255, 255, 255, 0.2);
        border-left-color: rgba(51, 204, 255, 0.65);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GalleryTagListEditor.vue?1312f3b9